// extracted by mini-css-extract-plugin
var _1 = "SVGIcon__hoverTarget--aC7du";
var _2 = "SVGIcon__svg--5b6ls";
export { _1 as "hoverTarget", _2 as "svg" }
